import * as PIXI from 'pixi.js'
import { globalData } from './globalData';
import { updateTotalBet } from './gameUI';
import { playDisable, playMinus, playOff, playOn, playPlus } from './soundManager';
import { tweenFadeAppear } from './utility';

export const getTotalBet = () =>
    globalData.totalBet


export class betPanel {
    betPanelContainer = null;
    betIcon = null;
    betPanel = null;
    plusButtonNormal = null;
    minusButtonNormal = null;
    betValueText = null;
    betIndex = 0;
    betValues = []
    enabled = true;
    maxBet = 0;
    minBet = 0;
    counter = 0;

    minusBtnHitGraphic = null;
    plusBtnHitGraphic = null;

    constructor(x = -160, y = 320) {

        // this.betValues = this.createBetArray(globalData.minBet, globalData.maxBet, 50);
        this.betValues = globalData.betSettings
        this.betPanelContainer = new PIXI.Container();
        this.betPanelContainer.scale.set(1)
        this.betIcon = new PIXI.Sprite(PIXI.Assets.get('bet_panel'));
        this.betIcon.anchor.set(0.5);
        this.betIcon.scale.set(1);
        this.betIcon.position.set(x, y);
        this.betIcon.interactive = true;
        this.betIcon.on('pointerdown', (event) => {
            this.toggleBetPanel();
            event.stopPropagation();
        });
        this.setupBetPanel();
        this.setupBetValueTextDisplay();
        this.betPanelContainer.addChild(this.betIcon);
        this.setupBetControler();
        globalData.bet = this.betValues[this.betIndex];
        //       updateTotalBet();
    }
    createBetArray(minBet, maxBet, count) {
        const bets = [];
        for (let i = 0; i < count; i++) {
            // Cubic scaling for more lower values
            const factor = Math.pow(i / (count - 1), 3); // Adjust the exponent for stronger emphasis
            const bet = minBet + factor * (maxBet - minBet);
            if (bet < 0.5) {
                bets.push(0.10)
            } else {
                bets.push(Math.round(bet));
            }
            // Optional: round to the nearest integer
        }
        return bets;
    }

    setupBetPanel() {
        this.betPanel = new PIXI.Sprite(PIXI.Assets.get('bet_select_panel'));
        this.betPanel.anchor.set(0.5, 1);
        this.betPanel.scale.set(1);
        this.betPanel.initialX = this.betIcon.x
        this.betPanel.initialY = this.betIcon.y + 100
        this.betPanel.finalX = this.betIcon.x
        this.betPanel.finalY = this.betIcon.y
        this.betPanel.position.set(this.betPanel.initialX, this.betPanel.initialY);
        this.betPanel.interactive = true;
        this.betPanel.visible = false;
        this.betPanelContainer.addChild(this.betPanel);

        this.drawRoundPanelGraphics()
    }

    setupBetValueTextDisplay() {
        const style = new PIXI.TextStyle({
            dropShadow: false,
            dropShadowAngle: 0,
            dropShadowBlur: 0,
            dropShadowColor: 0,
            dropShadowDistance: 0,
            stroke: 0,
            strokeThickness: 2,
            fill: '#ffffff',
            fontFamily: 'Arial',
            fontSize: 45,
            fontWeight: '700',
            align: 'center'
        });

        // this.betValueText = new PIXI.Text(this.betValues[this.betIndex], style);
        this.betValueText = new PIXI.Text(this.betValues[this.betIndex], style);
        this.betValueText.y = 20;
        this.betValueText.x = 0
        this.betValueText.anchor.set(0.5);
        this.betIcon.addChild(this.betValueText);
    }
    updateBetValueText(betIndex = this.betIndex) {
        this.betValueText.text = this.betValues[betIndex];
    }

    plusButtonDisabled = null;
    plusButtonDown = null;
    plusButtonHover = null;

    minusButtonHover = null;
    minusButtonDisabled = null;
    minusButtonDown = null;


    setupBetControler() {
        this.plusButtonNormal = new PIXI.Sprite(PIXI.Assets.get('plus_b_normal'));
        this.plusButtonNormal.anchor.set(0.5);
        this.plusButtonNormal.scale.set(1);
        this.plusButtonNormal.position.set(this.betIcon.x + 155, this.betIcon.y + 22)

        this.plusButtonHover = new PIXI.Sprite(PIXI.Assets.get('plus_b_selected'));
        this.plusButtonHover.anchor.set(0.5);
        this.plusButtonHover.visible = false;
        this.plusButtonNormal.addChild(this.plusButtonHover);

        this.plusButtonDown = new PIXI.Sprite(PIXI.Assets.get('plus_b_down'));
        this.plusButtonDown.anchor.set(0.5);
        this.plusButtonDown.visible = false;
        this.plusButtonNormal.addChild(this.plusButtonDown);

        this.plusButtonDisabled = new PIXI.Sprite(PIXI.Assets.get('plus_b_disabled'));
        this.plusButtonDisabled.anchor.set(0.5);
        this.plusButtonDisabled.visible = false;
        this.plusButtonNormal.addChild(this.plusButtonDisabled);

        this.plusBtnHitGraphic = new PIXI.Graphics();
        this.plusBtnHitGraphic.beginFill(0x202020, 1);
        this.plusBtnHitGraphic.drawCircle(0, 0, 75);
        this.plusBtnHitGraphic.endFill();
        this.plusBtnHitGraphic.alpha = 0
        this.plusBtnHitGraphic.interactive = true;
        this.plusBtnHitGraphic.cursor = 'pointer'
        this.plusButtonNormal.addChild(this.plusBtnHitGraphic);

        this.minusButtonNormal = new PIXI.Sprite(PIXI.Assets.get('minus_b_normal'));
        this.minusButtonNormal.anchor.set(0.5);
        this.minusButtonNormal.scale.set(1);
        this.minusButtonNormal.position.set(this.betIcon.x - 155, this.betIcon.y + 22)

        this.minusButtonHover = new PIXI.Sprite(PIXI.Assets.get('minus_b_selected'));
        this.minusButtonHover.anchor.set(0.5);
        this.minusButtonHover.visible = false;
        this.minusButtonNormal.addChild(this.minusButtonHover);

        this.minusButtonDown = new PIXI.Sprite(PIXI.Assets.get('minus_b_down'));
        this.minusButtonDown.anchor.set(0.5);
        this.minusButtonDown.visible = false;
        this.minusButtonNormal.addChild(this.minusButtonDown);

        this.minusButtonDisabled = new PIXI.Sprite(PIXI.Assets.get('minus_b_disabled'));
        this.minusButtonDisabled.anchor.set(0.5);
        this.minusButtonDisabled.visible = false;
        this.minusButtonNormal.addChild(this.minusButtonDisabled);

        this.minusBtnHitGraphic = new PIXI.Graphics();
        this.minusBtnHitGraphic.beginFill(0x202020, 1);
        this.minusBtnHitGraphic.drawCircle(0, 0, 75);
        this.minusBtnHitGraphic.endFill();
        this.minusBtnHitGraphic.alpha = 0
        this.minusBtnHitGraphic.interactive = true;
        this.minusBtnHitGraphic.cursor = 'pointer'
        this.minusButtonNormal.addChild(this.minusBtnHitGraphic);

        this.plusBtnHitGraphic.on('pointerover', () => {
            this.plusButtonHover.visible = true;
        })
        this.plusBtnHitGraphic.on('pointerout', () => {
            this.plusButtonHover.visible = false;
        })
        this.plusBtnHitGraphic.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                this.increaseRoundValue();
            }
        })
        this.plusBtnHitGraphic.on('pointerup', () => {
            this.plusButtonDown.visible = false;
        })
        this.plusBtnHitGraphic.on('pointerupoutside', () => {
            this.plusButtonDown.visible = false;
        });

        this.minusBtnHitGraphic.on('pointerover', () => {
            this.minusButtonHover.visible = true;
        })
        this.minusBtnHitGraphic.on('pointerout', () => {
            this.minusButtonHover.visible = false;
        })
        this.minusBtnHitGraphic.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                // disable()
                this.decreaseRoundValue();
            }
        })
        this.minusBtnHitGraphic.on('pointerupoutside', () => {
            this.minusButtonDown.visible = false;
        });
        this.minusBtnHitGraphic.on('pointerup', () => {
            this.minusButtonDown.visible = false;
        })

        this.betPanelContainer.addChild(this.plusButtonNormal, this.minusButtonNormal);
    }

    disablePanel() {
        this.minusBtnHitGraphic.interactive = false;
        this.plusBtnHitGraphic.interactive = false;
        this.betIcon.interactive = false;
        this.betValueText.style.fill = 0x959595
        this.plusButtonNormal.children[2].visible = true;
        this.minusButtonNormal.children[2].visible = true;
        this.enabled = false;
    }
    enablePanel() {
        this.minusBtnHitGraphic.interactive = true;
        this.plusBtnHitGraphic.interactive = true;
        this.betIcon.interactive = true;
        this.betValueText.style.fill = 0xffffff;
        this.plusButtonNormal.children[2].visible = false;
        this.minusButtonNormal.children[2].visible = false;

        // if (this.betIndex === this.betValues.length - 1) {
        //     this.plusButtonNormal.children[2].visible = true;
        // }
        // if (this.betIndex === 0) {
        //     this.minusButtonNormal.children[2].visible = true;
        // }
        this.enabled = true;
    }

    toggleBetPanel() {
        if (this.betPanel.visible) {
            tweenFadeAppear(this.betPanel, false)
            playOff()
        }
        else {
            tweenFadeAppear(this.betPanel, true)
            playOn()
        }
    }


    increaseRoundValue() {
        if (this.betIndex < globalData.betSettings.length - 1) {            
            globalData.bet = globalData.betSettings[this.betIndex + 1]
            this.betIndex = globalData.betSettings.indexOf(globalData.bet)
            // globalData.bet = globalData.betSettings[this.betIndex+1]
            // globalData.bet = Math.round(globalData.bet) + 1;
            this.betValueText.text = globalData.bet;
            //   this.updateBetValueText();
            this.plusButtonDown.visible = true;
            // if (this.betIndex === this.betValues.length - 1) {
            //     this.plusButtonDisabled.visible = true;
            // }
            // else {
            //     this.minusButtonDisabled.visible = false
            // }
            //  globalData.bet = this.betValues[this.betIndex];
            updateTotalBet();
            playPlus();
        }
        else {
            playDisable();
        }
    }

    decreaseRoundValue() {        
        if (this.betIndex > 0) {
            // if (globalData.bet > 1) {
                globalData.bet = globalData.betSettings[this.betIndex - 1]
                this.betIndex = globalData.betSettings.indexOf(globalData.bet)
            // } else {
            //     globalData.bet = 0.10
            // }
            this.betValueText.text = globalData.bet;
            //   this.updateBetValueText();
            this.minusButtonDown.visible = true;
            if (this.betIndex === 0) {
                //   this.minusButtonDisabled.visible = true;
            }
            if (this.betIndex < this.betValues.length - 1 && this.plusButtonDisabled.visible) {
                //  this.plusButtonDisabled.visible = false
            }

            //  this.updateBetValueText();
            // globalData.bet = this.betValues[this.betIndex];
            updateTotalBet();
            playMinus();
        }
        else {
            playDisable();
        }
    }

    setRoundValue(index) {
        this.updateBetValueText();
        globalData.bet = this.pannelBetArray[index];
        this.betValueText.text = this.pannelBetArray[index];
        updateTotalBet();
        playPlus();
        this.betIndex = index;
        this.toggleBetPanel();
    }

    buttonGraphics = []
    pannelBetArray = []
    drawRoundPanelGraphics() {
        const style = new PIXI.TextStyle({
            dropShadow: false,
            dropShadowAngle: 0,
            dropShadowBlur: 0,
            dropShadowColor: 0,
            dropShadowDistance: 0,
            stroke: 0,
            strokeThickness: 0,
            fill: '#ffffff',
            fontFamily: 'Arial',
            fontSize: 24,
            fontWeight: '700',
            align: 'center'
        });

        let i = 0;
        let noOfColumn = 3;
        let noOfRow = Math.ceil(globalData.betSettings.length / noOfColumn)
        this.pannelBetArray = globalData.betSettings

        for (let row = 0; row < noOfRow; row++) {
            if (globalData.betSettings.length % noOfColumn !== 0) {
                if (row === noOfRow - 1) {
                    noOfColumn = globalData.betSettings.length % noOfColumn
                }
            }

            for (let column = 0; column < noOfColumn; column++) {
                this.buttonGraphics[i] = new PIXI.Graphics();
                this.buttonGraphics[i].beginFill(0xffffff, 0.01);
                this.buttonGraphics[i].drawRoundedRect(column * 82 - this.betPanel.width / 2 + 28, 10 - this.betPanel.height + row * 65, 80, 60, 10);
                this.buttonGraphics[i].endFill();
                this.buttonGraphics[i].interactive = true;
                this.betPanel.addChild(this.buttonGraphics[i]);

                const panelBetValueText = new PIXI.Text(this.pannelBetArray[i], style);
                panelBetValueText.x = column * 82 - this.betPanel.width / 2 + 70;
                panelBetValueText.y = 10 - this.betPanel.height + row * 63 + 40
                panelBetValueText.anchor.set(0.5);
                this.buttonGraphics[i].addChild(panelBetValueText);

                this.buttonGraphics[i].on('pointerdown', (event) => {
                    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                        // disable()
                        this.buttonGraphics.interactive = true
                        this.buttonGraphics.cursor = "pointer"
                        var self = event.currentTarget
                        var index = this.buttonGraphics.indexOf(self)
                        this.setRoundValue(index);
                    }
                });


                if (i < globalData.betSettings.length)
                    i++
            }
        }
    }

    resize() {

    }

}